<span class="pts-currency-span" >
    {{displayCurrency}}
</span>

